module.exports = __webpack_public_path__ + "static/media/bannimg.2622815d.png";